export default __webpack_public_path__ + "static/media/5.a1e91cdf.jpg";